import script from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"

import "./AiPrompts.vue?vue&type=style&index=0&id=5de54702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de54702"]])

export default __exports__